import { MetricReader } from '@opentelemetry/sdk-metrics';
import { internal } from '@opentelemetry/core';

import { isEqualsMetrics } from '../../utils/equals';

export class CacheMetricReader extends MetricReader {
  constructor(options, aggregator) {
    super({
      aggregationSelector: options.exporter.selectAggregation?.bind(
        options.exporter,
      ),
      aggregationTemporalitySelector:
        options.exporter.selectAggregationTemporality?.bind(options.exporter),
      metricProducers: options.metricProducers,
    });
    this.exporter = options.exporter;
    this.cache = {};
    this.aggregator = aggregator;
  }

  onInitialized() {
    this.aggregator.harvest = this.harvest.bind(this);
  }

  async harvest(options) {
    const { resourceMetrics } = await this.collect(options);
    const filteredResourceMetrics = {
      resource: resourceMetrics.resource,
      scopeMetrics: [],
    };

    let countMetrics = 0;

    resourceMetrics.scopeMetrics.forEach((scopeMetrics) => {
      let prefixKey =
        resourceMetrics.resource.attributes['service.name'] ?? 'default';

      prefixKey = `${prefixKey}.${scopeMetrics.scope.name}`;

      const filteredScopeMetrics = {
        scope: scopeMetrics.scope,
        metrics: [],
      };

      scopeMetrics.metrics.forEach((metric) => {
        const key = `${prefixKey}.${metric.descriptor.name}`;

        if (this.cache[key] && isEqualsMetrics(this.cache[key], metric)) {
          return;
        }

        this.cache[key] = metric;
        filteredScopeMetrics.metrics.push(metric);
        countMetrics += 1;
      });
      filteredResourceMetrics.scopeMetrics.push(filteredScopeMetrics);
    });

    if (countMetrics > 0) {
      // eslint-disable-next-line no-underscore-dangle
      await internal._export(this.exporter, filteredResourceMetrics);
    }
  }

  shutdown() {
    this.exporter.shutdown();
  }
}
